module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.ec4c036c.woff2";